import React from "react";
import { cn } from "@/lib/utils";

// Native date / time / datetime field, styled to match the design system.
export interface DateTimeFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  mode?: "date" | "time" | "datetime-local";
}

export const DateTimeField = React.forwardRef<HTMLInputElement, DateTimeFieldProps>(
  ({ mode = "datetime-local", className, ...props }, ref) => (
    <input
      ref={ref}
      type={mode}
      className={cn(
        "flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900",
        "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:border-transparent",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
DateTimeField.displayName = "DateTimeField";
